import { useContext } from 'react';
import { Context } from '../../../../context/AppContext';

const useLandingSearchLogic = () => {
  const {
    media: { mobile },
  } = useContext(Context);

  return { mobile };
};

export default useLandingSearchLogic;
